// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const moltres: PokeData = {
  "id": 146,
  "name": "moltres",
  "height": 20,
  "weight": 600,
  "base_experience": 261,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "leer",
    "ember",
    "flamethrower",
    "peck",
    "solar-beam",
    "fire-spin",
    "agility",
    "sky-attack",
    "endure",
    "safeguard",
    "sunny-day",
    "ancient-power",
    "heat-wave",
    "overheat",
    "roost",
    "air-slash",
    "incinerate",
    "hurricane",
    "burn-up"
  ],
  "moves": [
    "gust",
    "leer",
    "ember",
    "flamethrower",
    "peck",
    "solar-beam",
    "fire-spin",
    "sky-attack",
    "sunny-day",
    "ancient-power",
    "roost",
    "air-slash",
    "hurricane"
  ],
  "evolution_chain": {
    "id": 75,
    "item": null,
    "species": [
      {
        "name": "moltres",
        "order": 178,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 119,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
